import {
  getStepData,
  getNextStep,
  checkHasNextStep,
  checkHasPreviousStep,
  updateStepData
} from "../helpers/stepHelper";
const useInputSetupWizardStepsHelper = () => ({
  getStepData,
  getNextStep,
  checkHasNextStep,
  checkHasPreviousStep,
  updateStepData
});
export default useInputSetupWizardStepsHelper;
